export enum WORKFLOW_TYPE {
  COUNTRY_LEVEL,
  LOCATION_LEVEL,
  BUILDING_LEVEL,
  // not implemented
  TECHNOLOGY_LEVEL,
}